module.exports = __webpack_public_path__ + "img/conceptquestion.6eed4fab.png";